import React, { PropsWithChildren } from 'react';
import { TrashOutlined, ButtonProps, IconButton, Button } from '@landr/maestro';
import { t } from '@lingui/macro';
import { noop } from 'utils/noop';
import { CreatorSampleType } from 'controllers/business/Creator/Creator.types';
import useRemoveFromCreatorButton from 'components/Creator/RemoveFromCreatorButton/useRemoveFromCreatorButton';

export interface RemoveFromCreatorButtonProps extends ButtonProps {
    onClick?: () => void;
    sample?: CreatorSampleType;
    key?: string | number;
    id?: string | number;
}

export const RemoveFromCreatorButton: React.FC<
    PropsWithChildren<RemoveFromCreatorButtonProps>
> = ({ id, key, onClick = noop, sample, children, ...props }) => {
    const { handleClick } = useRemoveFromCreatorButton({ sample, onClick });

    return children ? (
        <Button
            aria-label={t`Remove`}
            onClick={handleClick}
            {...props}
            key={key}
        >
            {children}
        </Button>
    ) : (
        <IconButton
            label={t`Remove`}
            icon={TrashOutlined}
            onClick={handleClick}
            {...props}
            key={key}
        ></IconButton>
    );
};

export default RemoveFromCreatorButton;
